const imerrInvalidMapInitialObjValue = value => new TypeError(
  `Invalid initial value "${value}".`
    + 'Expected plain Object or keyed collection.')

const imerrInvalidMapInitialListValue = value => new TypeError(
  `Invalid initial value "${value}".`
    + 'Expected Array of [k, v] entries or keyed collection.')

const imerrUpdateKeyNotFound = key => new Error(
  `update key not found, "${key}"`)

const imerrValueCannotBeHashed = value => new Error(
  `Value type ${typeof value} cannot be hashed.`)

const imerrInvalidKeyNonExtensible = () => new Error(
  'Non-extensible objects are not allowed as keys.')

export {
  imerrInvalidMapInitialObjValue,
  imerrInvalidMapInitialListValue,
  imerrInvalidKeyNonExtensible,
  imerrUpdateKeyNotFound,
  imerrValueCannotBeHashed
}
